export const SHIFT_INVITES_HELP_URL =
  "https://support.clipboardhealth.com/hc/en-us/articles/21082192844951-Shift-Invites-feature-For-Facilities";
